import moment, { Moment } from "moment";

/**
 * Rules for a live event's TV fields, mirrored from the admin API
 * (`LiveController`) so the form can say what is wrong before saving.
 */

/** The HLS master the TV plays: an `https` URL whose path ends in `.m3u8`. */
export function streamUrlError(value: string): string | null {
  const url = value.trim();
  if (!url) return null; // empty is allowed; TV visibility needs it, see tvReadiness
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return "Enter a full URL, for example https://live.klooma.com/events/1/master.m3u8";
  }
  if (parsed.protocol !== "https:") return "The stream URL must start with https://";
  if (!parsed.pathname.toLowerCase().endsWith(".m3u8")) return "The stream URL must end in .m3u8";
  return null;
}

/** What is missing before the event may be switched on for TV (empty = ready). */
export function tvReadiness(input: {
  hasPoster: boolean;
  stream: string;
  startDate?: Moment;
  endDate?: Moment;
}): string[] {
  const missing: string[] = [];
  if (!input.hasPoster) missing.push("poster");
  if (!input.stream.trim() || streamUrlError(input.stream)) missing.push("stream");
  if (!input.startDate) missing.push("start");
  if (!input.endDate) missing.push("end");
  return missing;
}

/** The API stores and returns UTC; the form edits in the browser's zone. */
export const fromApiDate = (value?: string | null): Moment | undefined =>
  value ? moment.utc(value).local() : undefined;

export const toApiDate = (value: Moment): string => moment(value).utc().format("YYYY-MM-DD HH:mm:ss");

/** An end that is not after the start is refused by the API. */
export const endBeforeStart = (start?: Moment, end?: Moment): boolean =>
  !!start && !!end && !end.isAfter(start);
